export const AnalyticsKeys = {
  ACTIVITY_ALL_VIEW: 'activity.all.view',
  ACTIVITY_WATCHING_VIEW: 'activity.watching.view',
  HISTORY_VIEW: 'history.view',
  PEOPLE_VIEW: 'people-search.view',
  PROFILE_PAGE_VIEW: 'profile-page.view',
  PROFILE_WORKED_ON_PAGE_VIEW: 'profile-worked-on-page.view',
  PROFILE_SETTINGS_CLOSE_ACCOUNT_VIEW: 'profile-settings.close-account.view',
  PROFILE_SETTINGS_EMAIL_VIEW: 'profile-settings.email.view',
  PROFILE_SETTINGS_GENERAL_VIEW: 'profile-settings.general.view',
  PROFILE_SETTINGS_PROFILE_AND_VISIBILITY_VIEW: 'profile-settings.profile-and-visibility.view',
  PROFILE_SETTINGS_PRIVACY_VIEW: 'profile-settings.privacy.view',
  PROFILE_SETTINGS_PRODUCT_VIEW: 'profile-settings.product.view',
  PROFILE_SETTINGS_SECURITY_VIEW: 'profile-settings.security.view',
  PROFILE_SETTINGS_TWO_STEP_VERIFICATION_VIEW: 'profile-settings.security.two-step-verification.view',
  PROFILE_SETTINGS_API_TOKENS_VIEW: 'profile-settings.security.api-tokens.view',
  PROFILE_SETTINGS_RECENT_DEVICES_VIEW: 'profile-settings.security.recent-devices.view',
  PROFILE_SETTINGS_CONNECTED_APPS_VIEW: 'profile-settings.connected-apps.view',
  TEAM_PROFILE_VIEW: 'team-profile.view',
  KUDOS_PAGE_VIEW: 'kudos-page.view',
  TEAM_PROFILE_BROWSE_ALL: 'team-profile.browse-all',
  ALL_TEAMS_DISABLED: 'profile-search.view.all-teams.disabled',
  // TODO: remove these once we move to a new analytics platform
  LEGACY_ACTIVITY_ALL_VIEW: 'newsfeed.view'
};
export const analyticsKeyToEventMap = {
  [AnalyticsKeys.PROFILE_PAGE_VIEW]: 'userProfile',
  [AnalyticsKeys.TEAM_PROFILE_BROWSE_ALL]: 'teamsPage'
};
export let AnalyticsEventSource = /*#__PURE__*/function (AnalyticsEventSource) {
  AnalyticsEventSource["USER_PROFILE_SCREEN"] = "userProfileScreen";
  AnalyticsEventSource["USER_PROFILE_ABOUT"] = "userProfileAbout";
  AnalyticsEventSource["USER_WORK_SCREEN"] = "userWorkScreen";
  AnalyticsEventSource["TEAM_PROFILE_SCREEN"] = "teamProfileScreen";
  AnalyticsEventSource["TEAM_PROFILE_ABOUT"] = "teamProfileAbout";
  AnalyticsEventSource["TEAM_RESTORE_SCREEN"] = "teamRestoreScreen";
  AnalyticsEventSource["TEAM_RESTORE_SUCCESS_FLAG"] = "teamReactivatedSuccessflag";
  AnalyticsEventSource["TEAM_RESTORE_ERROR_FLAG"] = "teamReactivatedErrorflag";
  AnalyticsEventSource["CREATE_TEAM_MODAL"] = "createTeamModal";
  AnalyticsEventSource["DIRECTORY_SCREEN"] = "directoryScreen";
  AnalyticsEventSource["PEOPLE_HOME"] = "peopleHome";
  AnalyticsEventSource["PEOPLE_DRAWER"] = "peopleDrawer";
  AnalyticsEventSource["USER_MENU"] = "userMenu";
  AnalyticsEventSource["ADD_PEOPLE_MODAL"] = "addPeopleModal";
  AnalyticsEventSource["CLIENT_METRICS"] = "clientMetrics";
  AnalyticsEventSource["DIRECTORY_APP"] = "directoryApp";
  AnalyticsEventSource["INITIALS_DIALOG"] = "avatarInitialsPicker";
  AnalyticsEventSource["KUDOS_SCREEN"] = "kudos";
  AnalyticsEventSource["PROFILE_CARD"] = "profilecard";
  AnalyticsEventSource["TEAMS_PAGE"] = "teamsPage";
  return AnalyticsEventSource;
}({});
export let AnalyticsEventActions = /*#__PURE__*/function (AnalyticsEventActions) {
  AnalyticsEventActions["ACCEPTED"] = "accepted";
  AnalyticsEventActions["CLICKED"] = "clicked";
  AnalyticsEventActions["CLOSED"] = "closed";
  AnalyticsEventActions["COLLAPSED"] = "collapsed";
  AnalyticsEventActions["CREATED"] = "created";
  AnalyticsEventActions["DECLINED"] = "declined";
  AnalyticsEventActions["DELETED"] = "deleted";
  AnalyticsEventActions["EDITED"] = "edited";
  AnalyticsEventActions["EXPANDED"] = "expanded";
  AnalyticsEventActions["EXPOSED"] = "exposed";
  AnalyticsEventActions["FAILED"] = "failed";
  AnalyticsEventActions["JOINED"] = "joined";
  AnalyticsEventActions["REDIRECTED"] = "redirected";
  AnalyticsEventActions["REMOVED"] = "removed";
  AnalyticsEventActions["SENT"] = "sent";
  AnalyticsEventActions["SORTED"] = "sorted";
  AnalyticsEventActions["STARTED"] = "started";
  AnalyticsEventActions["OPENED"] = "opened";
  AnalyticsEventActions["SHOWN"] = "shown";
  AnalyticsEventActions["SUBMITTED"] = "submitted";
  AnalyticsEventActions["SUCCEEDED"] = "succeeded";
  AnalyticsEventActions["TRIGGERED"] = "triggered";
  AnalyticsEventActions["TYPED"] = "typed";
  AnalyticsEventActions["VIEWED"] = "viewed";
  AnalyticsEventActions["MOUNTED"] = "mounted";
  AnalyticsEventActions["MOVED"] = "moved";
  AnalyticsEventActions["DRAGGED"] = "dragged";
  AnalyticsEventActions["SELECTED"] = "selected";
  return AnalyticsEventActions;
}({});
export let AnalyticsEventSubjects = /*#__PURE__*/function (AnalyticsEventSubjects) {
  AnalyticsEventSubjects["TEAM_LINK"] = "teamLink";
  AnalyticsEventSubjects["BUTTON"] = "button";
  AnalyticsEventSubjects["MODAL_DIALOG"] = "modalDialog";
  AnalyticsEventSubjects["FORM"] = "form";
  AnalyticsEventSubjects["ERROR"] = "error";
  return AnalyticsEventSubjects;
}({});